import { toNumber, toString } from "lodash";

export const number = <Value, Fallback = number>(
  value: Value,
  fallback: Fallback = null as Fallback
) => {
  if (!value) return fallback;
  return toNumber(value);
};

export const string = <Value, Fallback = string>(
  value: Value,
  fallback: Fallback = null as Fallback
) => {
  if (!value) return fallback;
  return toString(value);
};

export const boolean = <Value, Fallback = boolean>(
  value: Value,
  fallback: Fallback = null as Fallback
) => {
  if (!value) return fallback;
  return Boolean(value);
};

export const array = <Value, Fallback = any[]>(
  value: Value,
  fallback: Fallback = [] as Fallback
) => {
  if (Array.isArray(value) && value.length) return value;
  return fallback;
};

export const cast = {
  number,
  string,
  boolean,
  array,
};
